import * as React from "react";
import styled from "styled-components";

import { Button } from "src/library/components/Button";
import { Input } from "src/library/components/Forms";
import { Icon } from "src/library/components/Icon";
import { Icons } from "src/library/components/Icon/types";

interface PricePercentageChangeFormProps {
  percentage: number;
  onSubmit: (price: number) => void;
  updating: boolean;
  disabled?: boolean;
}

const PricePercentageChangeForm: React.ReactFCWithChildren<PricePercentageChangeFormProps> = props => {
  const [ percentage, changePercentage ] = React.useState<number>(props.percentage);
  const [ showConfirm, setShowConfirm ] = React.useState<boolean>(false);

  React.useEffect(() => {
    if (percentage !== props.percentage) {
      setShowConfirm(true);
    } else {
      setShowConfirm(false);
    }
  }, [ percentage ]);

  React.useEffect(() => {
    setShowConfirm(false);
  }, [ props.updating ]);

  return (
    <PricePercentageChangeWrapper>
      <Input
        loading={props.updating}
        Append="%"
        name="percentageChange"
        inputType="number"
        label=""
        as="input"
        disabled={props.disabled ? props.disabled : false}
        handleChange={e => changePercentage(parseFloat(e.target.value))}
        value={percentage}
        min="0"
        max="100"
      />

      {showConfirm && (
        <Button
          loading={props.updating}
          onClick={() => {
            changePercentage(percentage);
            props.onSubmit(percentage);
          }}
        >
          <Icon
            $fillColor="white"
            icon={Icons.TICK}
          />
        </Button>
      )}
    </PricePercentageChangeWrapper>
  );
};

const PricePercentageChangeWrapper = styled.div`
  display: flex;
  position: relative;
`;

export default PricePercentageChangeForm;
